var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"fill":"none","height":_vm.height,"viewBox":"0 0 14 8","width":_vm.width,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12.9999 1L6.99988 7L0.999878 0.999999","stroke":_vm.fill,"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }